import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
import { Button, DialogActions, DialogContent, Dialog, DialogTitle, Stack, Typography } from "@mui/material";

export default function DownloadArchiveDialog(props) {
    const handleClose = () => {
        props.onClose();
    };
    const [state, setState] = useState({ phase: "ask" });

    useEffect(() => {
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };
        fetch("/api/4f791de494c44d60b505e6180fedc041/" + props.state.params.uid, requestOptions)
            .then((response) => {
                return response.json();
            })
            .then((res) => {
                switch (res.res) {
                    case "ok":
                        setState((state) => ({
                            ...state,
                            rep: res.pld,
                            phase: "rep"
                        }));


                        break;
                    case "err":
                        break;
                    default:
                        break;
                }
            });
    }, []);
    return (
        <Dialog onClose={handleClose} aria-labelledby="add-user-dialog" open={props.state.opened} maxWidth="md" fullWidth={false}>
            <DialogTitle id="add-user-dialog">
                <Typography variant="h5">Téléchargement de l'archive</Typography>
            </DialogTitle>
            <DialogContent dividers>
                {state.phase === "ask" && <Typography variant="body1">Demande en cours</Typography>}
                {state.phase === "rep" && state.rep === "done" && <Stack>
                    <Typography variant="body1">Demande effectuée</Typography>
                    <Typography variant="body1">Vous allez recevoir un lien  quand l'archive sera disponible</Typography>
                </Stack>}
                {state.phase === "rep" && state.rep === "dup" && <Stack>
                    <Typography variant="body1">Vous avez déjà demandé un téléchargement</Typography>
                    <Typography variant="body1">Vous allez recevoir un lien quand l'archive sera disponible</Typography>
                </Stack>}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} variant="contained">
                    Fermer
                </Button>
            </DialogActions>
        </Dialog>
    );
}
